import { GlBadge, GlIcon, GlSprintf, GlTooltipDirective } from '@gitlab/ui';
import { n__ } from '~/locale';
export default {
    name: 'PackageTags',
    components: {
        GlBadge,
        GlIcon,
        GlSprintf
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        tagDisplayLimit: {
            type: Number,
            required: false,
            default: 2
        },
        tags: {
            type: Array,
            required: true
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        tagCount () {
            return this.tags.length;
        },
        tagsToRender () {
            return this.tags.slice(0, this.tagDisplayLimit);
        },
        moreTagsDisplay () {
            return Math.max(0, this.tags.length - this.tagDisplayLimit);
        },
        moreTagsTooltip () {
            if (this.moreTagsDisplay) {
                return this.tags.slice(this.tagDisplayLimit).map((x)=>x.name).join(', ');
            }
            return '';
        },
        tagsDisplay () {
            return n__('%d tag', '%d tags', this.tagCount);
        }
    },
    methods: {
        tagBadgeClass (index) {
            return {
                'gl-hidden': true,
                '!gl-flex': this.tagCount === 1,
                '@md/panel:!gl-flex': this.tagCount > 1,
                'gl-mr-2': index !== this.tagsToRender.length - 1,
                'gl-ml-3': !this.hideLabel && index === 0
            };
        }
    }
};
